import { useRef } from 'react';

/** Shallow equality for flat config objects (one level of own keys). */
export function shallowEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
  const left = a as Record<string, unknown>;
  const right = b as Record<string, unknown>;
  const keys = Object.keys(left);
  if (keys.length !== Object.keys(right).length) return false;
  for (const key of keys) {
    if (!Object.prototype.hasOwnProperty.call(right, key) || !Object.is(left[key], right[key])) {
      return false;
    }
  }
  return true;
}

/**
 * Keeps the previous object identity while the value stays shallow-equal, so
 * merged config objects (theme, consent, availability, ...) are stable across
 * renders and safe to use as effect dependencies.
 */
export function useShallowStable<T>(value: T): T {
  const ref = useRef<T>(value);
  if (!shallowEqual(ref.current, value)) ref.current = value;
  return ref.current;
}
